import _ from 'lodash';

export default class LinksModel {
    constructor(links) {
        this.links = links;
        this.mlink = null;
    }

    set link(value) {
        if (value === null) {
            this.mlink = null;
        }
        if (_.find(this.links, { id: value })) {
            this.mlink = value;
        }
    }

    get link() {
        return this.mlink;
    }

    get linkContent() {
        const link = _.find(this.links, { id: this.mlink });
        if (link) {
            return link.content;
        }
        return null;
    }
}
